






























































































































































































































import { LoginVue } from "fs-pb-vue2/vueModels/auth/LoginVue";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import { FinServLoginModel } from "@/extensions/models/auth/FinServLoginModel";
import EbsEsia from "@/components/auth/EbsEsia.vue";
import { getCookie } from "fs-pb-vue2/utilities/cookieHelper";
import IAuthService from "fs-pb-vue2/services/auth/IAuthService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { container } from "@/inversify.config";
import LoginWithoutPassword from "@/components/auth/LoginWithoutPassword.vue";
import { clearLocalInitData } from "fs-pb-vue2/utilities/index";

@Component({
  components: { BackLink, EbsEsia, LoginWithoutPassword },
})
export default class Login extends LoginVue {

  loginWithoutPasswordOnProps: boolean = false;

  constructor() {
    super();
    this.loginWithoutPasswordOnProps = this.loginWithoutPasswordOn && this.isMobileBrowser;
  }
  /**
  * Признак входа без логина/пароля
  */
  get loginWithoutPasswordOn(): boolean {
    return window.localStorage.getItem('loginWithoutPasswordOn') === "1"
      && !!window.localStorage.getItem('deviceId')
      && !!window.localStorage.getItem('loginValue');
  }

  /**
   * Признак мобильного браузера
   */
  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  /**Модель авторизации */
  public model: FinServLoginModel = new FinServLoginModel();

  /**Ссылка на службу авторизации */
  get authService(): IAuthService<FinServLoginModel> {
    return container.get<IAuthService<FinServLoginModel>>(DiTokens.AuthService);
  }

  async mounted() {
    // if (!this.isOldClient) this.$router.push({path: '/register', query: this.$route.query});
    await this.init();
  }
  get isOldClient(): boolean {
    return getCookie("isOldClient") == "true";
  }

  closeLoginWithoutPassword() {
    window.localStorage.setItem('loginWithoutPasswordOn', undefined);
    this.loginWithoutPasswordOnProps = false;
  }

  /**Обработка сабмита формы */
  async loginHandlerF() {
    if (this.appStore.loading)
      return

    this.appStore.setLoading(true);

    this.valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

    if (!this.valid) {
      this.appStore.setLoading(false);
      return;
    }

    this.model = await this.authService.login(this.model);
    if (this.model.IsSuccess) {
      window.localStorage.setItem('loginValue', this.model.Alias);
      clearLocalInitData();
      this.alertService.clear();
      const returnUrl = this.$route.query.returnUrl || "/";
      this.$router.push(returnUrl);
    } else {
      this.appStore.setLoading(false);
      this.resetFormValidation();
    }
  }

  onLoginWithoutPassword = async (pin: string) => {
    if (this.appStore.loading)
      return

    this.appStore.setLoading(true);

    const login = window.localStorage.getItem('loginValue');
    const devId =  window.localStorage.getItem('deviceId');

    if(!login || !pin || !devId) {
      this.loginWithoutPasswordOnProps = false;
      return;
    }
    this.model.DevId = devId;
    this.model.Pin = pin;
    this.model.Alias = login;

    this.model = await this.authService.login(this.model);
    if (this.model.IsSuccess) {
      window.localStorage.setItem('loginValue', this.model.Alias)
      clearLocalInitData();
      this.alertService.clear();
      const returnUrl = this.$route.query.returnUrl || "/";
      this.$router.push(returnUrl);
    } else {
      this.appStore.setLoading(false);
    }
  }
  validateForm(): void {
    // Проверяем форму на валидность
    (this.$refs.form as any).validate();
  }

  resetFormValidation(): void {
    // Сбрасываем реззультаты валидации
    (this.$refs.form as any).resetValidation();
  }
}
